import { useState } from 'react';
import { num } from '../financeApi';

// 월별 올해/전년 묶음 막대. 두 계열이라 범례를 두고, 막대에 마우스를 올리면 그 달의 두 값과 증감을 보여준다.
// 색은 dataviz 기본 범주 팔레트 1·2번(파랑/주황) - 검증기 통과 조합.
export default function MonthlyCompareChart({ year, current, previous }: { year: number; current: number[]; previous: number[] }) {
  const [hover, setHover] = useState<number | null>(null);
  const max = Math.max(1, ...current, ...previous);
  const hasAny = current.some((v) => v > 0) || previous.some((v) => v > 0);

  if (!hasAny) return <p className="manage-side-empty" style={{ padding: 16 }}>아직 수입 내역이 없습니다.</p>;

  return (
    <div className="fin-chart">
      <div className="fin-legend">
        <span><i className="fin-swatch fin-swatch--previous" />{year - 1}년</span>
        <span><i className="fin-swatch fin-swatch--current" />{year}년</span>
      </div>
      <div className="fin-chart-plot" onMouseLeave={() => setHover(null)}>
        {current.map((value, i) => {
          const prev = previous[i];
          return (
            <div
              key={i}
              className={`fin-chart-col${hover === i ? ' is-hover' : ''}`}
              onMouseEnter={() => setHover(i)}
            >
              <div className="fin-chart-bars">
                <div className="fin-chart-bar fin-chart-bar--previous" style={{ height: `${(prev / max) * 100}%` }} />
                <div className="fin-chart-bar fin-chart-bar--current" style={{ height: `${(value / max) * 100}%` }} />
              </div>
              <span className="fin-chart-label">{i + 1}월</span>
              {hover === i && (
                <div className={`fin-tooltip${i >= 8 ? ' is-left' : ''}`}>
                  <b>{i + 1}월</b>
                  <div><i className="fin-swatch fin-swatch--current" />{year}년 {num(value)}원</div>
                  <div><i className="fin-swatch fin-swatch--previous" />{year - 1}년 {num(prev)}원</div>
                  {prev > 0 && (
                    <div className="fin-tooltip-sub">
                      증감 {value - prev >= 0 ? '+' : ''}{Math.round(((value - prev) / prev) * 1000) / 10}%
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
